import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-849a12f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "LoginTitle" }, "SmartLink™ RAOS ", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "LoginSubtitle" }, " Remote & Autonomous Operation System", -1))
const _hoisted_8 = [
  _hoisted_7
]

import { Ref, computed, ref } from 'vue';
import axios            from 'axios';
import router           from '@/router';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';
import CONSTAPIS        from '@/constants/apis';
import { TIMEOUTTIME }  from '@/constants/apis';
import { TOKEN, VISIBLE_PAGES } from '@/constants/labels';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { showConsoleError } from '@/functions/errors';



export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const store = useStore();

/********************************
 ************ VUETIFY ***********
 *******************************/
const { md, smAndDown} = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
const projectName       = computed(() => store.state.projectName);
const isRAOS = computed(() => projectName.value === 'SmartLinkRAOS')


/**
 * Component
 */
const valid:Ref<boolean>        =   ref(false);
const userName:Ref<string>      =   ref('');
const password:Ref<string>      =   ref('');
const iconAppend                =   ref('mdi-eye');
const typePassword              =   ref('password');
const boolPassword              =   ref(true);
const width                     =   computed(() => md.value?'50%':smAndDown.value?'70%':'700px');

/**
 * Rules Fields
 */
const fieldPassRules = ref (
[
    (value:string) => {
    if (value) return true

    return t('labels.errors.passRequired')
    }
    
]);
const fieldUserRules = computed ( () =>
    [
    (v:string) => !!v || t('labels.errors.userRequired'),
    (v:string) => v.length >= 4 || t('labels.errors.userError'),
],
)

//==================================================//
//===================== METHODS ====================//
//==================================================//

/**
 * Show password
 */
const changeType = () =>{
    boolPassword.value = !boolPassword.value
    if(boolPassword.value){
        iconAppend.value        = 'mdi-eye';
        typePassword.value      = 'password';
    }else{
        iconAppend.value        = 'mdi-eye-off';
        typePassword.value      = 'text';
    }
}

    /**
 * Post Login Form to API
 */
const submit = async () => {
    const params = {
        user : userName.value,
        pass : password.value,
    }
    await axios.get(CONSTAPIS.APIS.value.general.login, { params : params, timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then(
        (element) =>{
            let sesion = element.data.body;
            
            if(sesion.status === 'User Found'){
                localStorage.setItem('user', sesion.user);
                store.commit('setUserSesion',sesion.user);
                localStorage.setItem('rol', sesion.rol);
                store.commit('setUserRol',sesion.rol);

                const finalURL = isRAOS.value ? `/smartlinkRAOS/${VISIBLE_PAGES.raosinit}` : `/smartlink/${VISIBLE_PAGES.dashboard}`
                router.push(finalURL)
                store.commit('setAppBarPage','smartlinkPage');
            }
            else {
                let msg = sesion.status === 'User Not Found' ? t('snackbar.login.userNotFound') : t('snackbar.login.passWrong') ; 
                
                userName.value = '';
                password.value = '';
                store.dispatch('showSnackBar', {type: 'setSnackError', msg: msg})
            }
        }
    )
    .catch(function (error) {
        showConsoleError(error);
    });
}


return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    color: "transparent",
    width: "100%",
    height: "100%",
    class: _normalizeClass(["pt-8", !isRAOS.value ? 'align-content-center' : '']),
    style: {"text-align":"-webkit-center"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        color: "transparent",
        class: "text-start hc-group__LOGO"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            width: 120,
            alt: "Logo Smart Link",
            src: require('@/assets/Images/hcgroup.jpg')
          }, null, 8, _hoisted_1)
        ]),
        _: 1
      }),
      (!isRAOS.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            width: 500,
            alt: "Logo Smart Link",
            src: require('@/assets/Images/logoSmartLink.png')
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (isRAOS.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      (isRAOS.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true),
      _createVNode(_component_v_sheet, {
        class: "defaultCard LoginCard",
        width: width.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, {
            modelValue: valid.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((valid).value = $event)),
            onSubmit: _withModifiers(submit, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, { class: "text-start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "text-black" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: userName.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userName).value = $event)),
                            rules: fieldUserRules.value,
                            label: _unref(t)('labels.user'),
                            "prepend-icon": "mdi-account-hard-hat",
                            variant: "outlined",
                            required: ""
                          }, null, 8, ["modelValue", "rules", "label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: password.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                            rules: fieldPassRules.value,
                            type: typePassword.value,
                            "append-inner-icon": iconAppend.value,
                            label: _unref(t)('labels.pass'),
                            "prepend-icon": "mdi-lock",
                            variant: "outlined",
                            "onClick:appendInner": _cache[2] || (_cache[2] = ($event: any) => (changeType())),
                            required: ""
                          }, null, 8, ["modelValue", "rules", "type", "append-inner-icon", "label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                type: "submit",
                color: "bgCircular",
                block: "",
                class: "btnLogin mt-2 mb-3 text-white",
                disabled: !valid.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('buttons.login')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["modelValue", "onSubmit"])
        ]),
        _: 1
      }, 8, ["width"])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})